<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeCustomerStatus
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=2973-37221
 */
import type { BadgeCustomerStatusProps } from '../types/interfaces'

import { useBadgeCustomerStatus } from '../composables/use-badge-customer-status.hook'
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgeCustomerStatus',
})

const props = defineProps<BadgeCustomerStatusProps>()

const {
  color,
  text,
} = useBadgeCustomerStatus({ props })
</script>

<template>
  <AppBadge
    :color="color"
    :text="text"
  />
</template>
